import React, { useState, useEffect } from "react";

import {
  CInputGroup,
  CRow,
  CInputGroupPrepend,
  CInputGroupText,
  CSelect,
  CButton,
  CCard,
  CCardHeader,
  CCardBody,
  CCollapse,
  CLabel
} from "@coreui/react";
import { AiOutlineClear } from "react-icons/ai";
import { HiUserGroup } from "react-icons/hi";
import { IoMdSchool } from "react-icons/io";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Label } from "reactstrap";

import URL from "../../../config/api";
import axios from "../../../config/axios";

const ConsolidatedFilter = props => {
  const token = useSelector(state => state.user.token);
  const user = useSelector(state => state.user);

  const [groupList, setGroupList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [studentList, setStudentList] = useState([]);

  const [group, setGroup] = useState(0);
  const [region, setRegion] = useState(0);
  const [school, setSchool] = useState(0);
  const [student, setStudent] = useState(0);

  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");

  const [period, setPeriod] = useState("|");
  const [visible, setVisible] = useState(false);

  const checkUserRoles = () => {
    const roles = user.user_roles ? user.user_roles : [];
    // Não possui papéis definidos
    if (roles.length <= 0)
      return {
        group_id: 0,
        role_id: 0,
        region_id: 0,
        school_id: 0
      };
    // Possui mais do que um papel
    if (roles.length > 1)
      return {
        group_id: roles.map(e => e.group_id),
        role_id: roles.map(e => e.role_id),
        region_id: roles.map(e => e.region_id),
        school_id: roles.map(e => e.school_id)
      };
    // Possui apenas um papel
    return {
      group_id: roles[0].group_id === null ? 0 : roles[0].group_id,
      role_id: roles[0].role_id === null ? 0 : roles[0].role_id,
      region_id: roles[0].region_id === null ? 0 : roles[0].region_id,
      school_id: roles[0].school_id === null ? 0 : roles[0].school_id
    };
  };

  useEffect(() => {
    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (!res.data.success) return;
        const data = res.data.data;
        const groupId = checkUserRoles().group_id;
        const filteredData = Array.isArray(groupId)
          ? data.filter(e => groupId.includes(e.group_id ? e.group_id : e.id))
          : groupId !== 0
          ? data.filter(e => (e.group_id ? e.group_id : e.id) === groupId)
          : data;

        setGroupList(filteredData);
        if (!Array.isArray(groupId)) {
          setGroup(groupId);
          return;
        }
        if (
          groupId.length > 1 &&
          groupId.filter(e => e === groupId[0]).length >= groupId.length
        ) {
          setGroup(groupId[0]);
        }
      });
  }, []);
  useEffect(() => {
    // Regiões
    if (groupList.length === 0) return;
    axios
      .get(`${URL.api}access/region/listRegionFilter/${group}`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (!res.data.success) return;
        const data = res.data.data;
        const regionId = checkUserRoles().region_id;

        const filteredData = Array.isArray(regionId)
          ? data.filter(e => regionId.includes(e.region_id || e.id))
          : regionId !== 0
          ? data.filter(e => (e.region_id ? e.region_id : e.id) === regionId)
          : data;

        setRegionList(filteredData);
        if (!Array.isArray(filteredData)) {
          setRegion(filteredData.id);
          return;
        }
        if (filteredData.length === 1) {
          setRegion(filteredData[0].id || filteredData[0].region_id);
          return;
        }
        if (
          filteredData.length > 1 &&
          filteredData.filter(
            e =>
              (e.id || e.region_id) ===
              (filteredData[0].id || filteredData[0].region_id)
          ).length >= filteredData.length
        ) {
          setRegion(filteredData[0].id || filteredData[0].region_id);
        }
      });
  }, [group]);
  useEffect(() => {
    // Escolas
    if (regionList.length === 0) return;
    axios
      .get(`${URL.api}access/school/listSchoolFilter/${group}/${region}`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .then(res => {
        const data = res.data.data;
        const schoolId = checkUserRoles().school_id;
        const filteredData = Array.isArray(schoolId)
          ? data.filter(e =>
              schoolId.includes(e.school_id ? e.school_id : e.id)
            )
          : schoolId !== 0
          ? data.filter(e => (e.school_id ? e.school_id : e.id) === schoolId)
          : data;
        setSchoolList(filteredData);
        if (!Array.isArray(filteredData)) {
          setSchool(filteredData.id ? filteredData.id : filteredData.school_id);
          return;
        }
        if (filteredData.length === 1) {
          setSchool(
            filteredData[0].id ? filteredData[0].id : filteredData[0].school_id
          );
          return;
        }
        if (
          filteredData.length > 1 &&
          filteredData.filter(
            e =>
              (e.id || e.school_id) ===
              (filteredData[0].id || filteredData[0].school_id)
          ).length >= filteredData.length
        ) {
          setSchool(
            filteredData[0].id ? filteredData[0].id : filteredData[0].school_id
          );
        }
      });
  }, [region]);
  useEffect(() => {
    // Alunos
    if (schoolList.length === 0) return;
    axios
      .post(
        `${URL.api}access/user/listUserFilter`,
        {
          role: 7,
          group,
          region,
          school
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {
        if (res.data.success) {
          const data = res.data.data;
          setStudentList(data.filter(e => e.name !== "null"));
        }
      });
  }, [school]);

  const getPeriods = () => {
    const currentYear = new Date().getFullYear();

    return [
      {
        name: "1º Bimestre",
        dateStart: new Date(currentYear, 0, 1).toISOString().substring(0, 10),
        dateEnd: new Date(currentYear, 1, 28).toISOString().substring(0, 10)
      },
      {
        name: "2º Bimestre",
        dateStart: new Date(currentYear, 2, 1).toISOString().substring(0, 10),
        dateEnd: new Date(currentYear, 3, 30).toISOString().substring(0, 10)
      },
      {
        name: "1º Trimestre",
        dateStart: new Date(currentYear, 0, 1).toISOString().substring(0, 10),
        dateEnd: new Date(currentYear, 2, 31).toISOString().substring(0, 10)
      },
      {
        name: "2º Trimestre",
        dateStart: new Date(currentYear, 3, 1).toISOString().substring(0, 10),
        dateEnd: new Date(currentYear, 5, 30).toISOString().substring(0, 10)
      },
      {
        name: "3º Trimestre",
        dateStart: new Date(currentYear, 6, 1).toISOString().substring(0, 10),
        dateEnd: new Date(currentYear, 8, 30).toISOString().substring(0, 10)
      },
      {
        name: "1º Semestre",
        dateStart: new Date(currentYear, 0, 1).toISOString().substring(0, 10),
        dateEnd: new Date(currentYear, 5, 30).toISOString().substring(0, 10)
      },
      {
        name: "2º Semestre",
        dateStart: new Date(currentYear, 6, 1).toISOString().substring(0, 10),
        dateEnd: new Date(currentYear, 11, 31).toISOString().substring(0, 10)
      }
    ];
  };
  const changePeriod = period => {
    const splitedPeriod = period.split("|");
    setPeriod(period);
    setDateStart(splitedPeriod[0]);
    setDateEnd(splitedPeriod[1]);
  };
  const clearFilter = () => {
    if (groupList.length > 1) {
      setGroup(0);
    }
    if (regionList.length > 1) {
      setRegion(0);
      setRegionList([]);
    }
    if (schoolList.length > 1) {
      setSchool(0);
      setSchoolList([]);
    }
    if (studentList.length > 1) {
      setStudent(0);
      setStudentList([]);
    }

    setDateStart("");
    setDateEnd("");
    setPeriod("|");

    props.onClearFilter();
  };
  const changeGroup = id => {
    setGroup(id);
    setRegion(0);
    setSchool(0);
    setStudent(0);
    setRegionList([]);
    setSchoolList([]);
    setStudentList([]);
  };
  const changeRegion = id => {
    setRegion(id);
    setSchool(0);
    setStudent(0);
    setSchoolList([]);
    setStudentList([]);
  };
  const changeSchool = id => {
    setSchool(id);
    setStudent(0);
    setStudentList([]);
  };
  const changeStudent = id => {
    setStudent(id);
  };
  const checkFilterCriteria = () => group !== 0;

  const changeFilter = () => {
    const params = {
      group_id: group !== 0 ? group : "",
      region_id: region !== 0 ? region : "",
      school_id: school !== 0 ? school : "",
      user_id: student !== 0 ? student : "",
      from: dateStart,
      to: dateEnd
    };
    if (!checkFilterCriteria()) {
      toastr.warning("Atenção", "Você deverá selecionar um grupo.");
      return;
    }
    props.onChange(params);
  };
  return (
    <div className="d-flex align-items-end mb-4">
      <CRow className="flex-1">
        <div className="col-md-3">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Períodos</Label>
          </div>
          <CCard>
            <CCardHeader>
              <div
                className="d-flex align-items-center justify-content-between w-100"
                style={{ cursor: "pointer" }}
                onMouseDown={() => setVisible(!visible)}
              >
                <CLabel className="m-0" style={{ cursor: "pointer" }}>
                  <strong>Opções de filtro</strong>
                </CLabel>
                <i className="text-muted activity-collapse fa fa-chevron-down pointer cursor-pointer"></i>
              </div>
            </CCardHeader>
            <CCollapse show={visible}>
              <CCardBody>
                <CSelect
                  value={period}
                  placeholder="Períodos"
                  onChange={e => changePeriod(e.target.value)}
                >
                  <option value="|" key="0">
                    Todos
                  </option>
                  {getPeriods().map((period, index) => (
                    <option
                      value={`${period.dateStart}|${period.dateEnd}`}
                      key={index + 1}
                    >
                      {period.name}
                    </option>
                  ))}
                </CSelect>
                <hr />
                <div className="p-1">
                  <CLabel>De </CLabel>
                  <input
                    type="date"
                    className="w-100"
                    value={dateStart}
                    onChange={e => setDateStart(e.target.value)}
                  />
                </div>
                <div className="p-1">
                  <CLabel>Até </CLabel>
                  <input
                    type="date"
                    className="w-100"
                    value={dateEnd}
                    onChange={e => setDateEnd(e.target.value)}
                  />
                </div>
              </CCardBody>
            </CCollapse>
          </CCard>
        </div>
        <div className="col-md-3">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Grupos</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <HiUserGroup />
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={group}
              placeholder="Grupos"
              onChange={e => changeGroup(parseInt(e.target.value))}
              disabled={groupList.length <= 1}
            >
              {groupList.length > 0 && (
                <option value={0} key={0}>
                  Selecione um grupo
                </option>
              )}
              {groupList.length > 0 ? (
                groupList.map((group, index) => (
                  <option
                    value={group.group_id ? group.group_id : group.id}
                    key={index + 1}
                  >
                    {group.name}
                  </option>
                ))
              ) : (
                <option value={0} key={1}>
                  Não há grupos disponíveis
                </option>
              )}
            </CSelect>
          </CInputGroup>
        </div>
        <div className="col-md-3">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Regiões</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-globe"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={region}
              placeholder="Regiões"
              onChange={e => changeRegion(parseInt(e.target.value))}
              disabled={regionList.length <= 1}
            >
              {regionList.length > 0 && (
                <option value={0} key={0}>
                  Todas
                </option>
              )}
              {regionList.length > 0 ? (
                regionList.map((region, index) => (
                  <option value={region.id} key={index + 1}>
                    {region.name}
                  </option>
                ))
              ) : group !== 0 ? (
                <option value={0} key={999}>
                  Não há regiões disponíveis
                </option>
              ) : (
                <option value={0} key={998}>
                  Selecione um grupo antes
                </option>
              )}
            </CSelect>
          </CInputGroup>
        </div>
        <div className="col-md-3">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Escolas</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-institution"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={school}
              placeholder="Escolas"
              onChange={e => changeSchool(parseInt(e.target.value))}
              disabled={schoolList.length <= 1}
            >
              {schoolList.length > 0 && (
                <option value={0} key={0}>
                  Todas
                </option>
              )}
              {schoolList.length > 0 ? (
                schoolList.map((school, index) => (
                  <option value={school.id} key={index + 1}>
                    {school.name}
                  </option>
                ))
              ) : region !== 0 && group !== 0 ? (
                <option value={0} key={999}>
                  Não há escolas disponíveis
                </option>
              ) : (
                <option value={0} key={998}>
                  Selecione uma região antes
                </option>
              )}
            </CSelect>
          </CInputGroup>
        </div>
        <div className="col-md-3">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Estudantes</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <IoMdSchool />
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={student}
              placeholder="Estudantes"
              onChange={e => changeStudent(parseInt(e.target.value))}
              disabled={studentList.length < 1}
            >
              {schoolList.length > 0 && (
                <option value={0} key={0}>
                  Todos
                </option>
              )}
              {studentList.length > 0 ? (
                studentList.map((student, index) => (
                  <option value={student.id} key={index + 1}>
                    {student.name}
                  </option>
                ))
              ) : region !== 0 && school !== 0 ? (
                <option value={0} key={999}>
                  Não há estudantes disponíveis
                </option>
              ) : (
                <option value={0} key={998}>
                  Selecione uma escola antes
                </option>
              )}
            </CSelect>
          </CInputGroup>
          <br />
          <div className="btn-group">
            <CButton
              color="primary"
              className="d-flex align-items-center"
              onClick={changeFilter}
            >
              <i className="fa fa-filter mr-2"></i>Filtrar
            </CButton>
            <CButton
              color="danger"
              className="d-flex align-items-center"
              onClick={clearFilter}
            >
              <AiOutlineClear className="mr-2" /> Limpar
            </CButton>
          </div>
        </div>
      </CRow>
    </div>
  );
};
export default ConsolidatedFilter;
